/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull browser-sdk'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 2
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/moecorporation/staging/implementation/browser-sdk)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'staging';

export const ApiKey: Record<Environment, string> = {
  staging: '6d1dbf6529499fdaa3e5c6defe1adc87'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '2',
    branch: 'main',
    source: 'browser-sdk',
    versionId: '79f8f123-1d94-467c-9bba-515063ec0a4b'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface ChatContinueProperties {
  /**
   * How many *characters* are in the chat when the message is sent.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  characterCount: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  personaId?: number;
  timestamp: string;
}

export interface ChatGenerationCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  characterId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * Time taken to generate response in milliseconds
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  generationDurationMs: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  personaId?: number;
  /**
   * The response length in characters.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  responseLength: number;
  timestamp: string;
}

export interface ChatGenerationErrorProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  errorMessage: string;
  /**
   * One of: "rate-limit", "timeout", "connection", "unknown"
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | ^(rate-limit|timeout|connection|unknown)$ |
   */
  errorType: string;
  timestamp: string;
}

export interface ChatMessageDeletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  messageId: number;
  /**
   * Type of message - must be either "user" or "character"
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | ^(user|character)$ |
   */
  messageType: string;
  timestamp: string;
}

export interface ChatMessageEditedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  messageId: number;
  /**
   * Type of message - must be either "user" or "character"
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | ^(user|character)$ |
   */
  messageType: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  personaId?: number;
  timestamp: string;
}

export interface ChatMessageRegeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  characterId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  messageId: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  regenerationCount: number;
  timestamp: string;
}

export interface ChatMessageSentProperties {
  /**
   * How many *characters* are in the chat when the message is sent.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  characterCount: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  hasMultipleCharacters: boolean;
  /**
   * Message length in characters.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  messageLength: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  personaId?: number;
  timestamp: string;
}

export interface ChatRewoundProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chatId: number;
  /**
   * Number of messages removed by the rewind action.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  messagesDeleted: number;
  timestamp: string;
}

export class ChatContinue implements BaseEvent {
  event_type = 'Chat Continue';

  constructor(
    public event_properties: ChatContinueProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatGenerationCompleted implements BaseEvent {
  event_type = 'Chat Generation Completed';

  constructor(
    public event_properties: ChatGenerationCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatGenerationError implements BaseEvent {
  event_type = 'Chat Generation Error';

  constructor(
    public event_properties: ChatGenerationErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageDeleted implements BaseEvent {
  event_type = 'Chat Message Deleted';

  constructor(
    public event_properties: ChatMessageDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageEdited implements BaseEvent {
  event_type = 'Chat Message Edited';

  constructor(
    public event_properties: ChatMessageEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageRegenerated implements BaseEvent {
  event_type = 'Chat Message Regenerated';

  constructor(
    public event_properties: ChatMessageRegeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageSent implements BaseEvent {
  event_type = 'Chat Message Sent';

  constructor(
    public event_properties: ChatMessageSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatRewound implements BaseEvent {
  event_type = 'Chat Rewound';

  constructor(
    public event_properties: ChatRewoundProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Chat Continue
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Continue)
   *
   * Fired when user continues conversation without sending a message.
   *
   * @param properties The event's properties (e.g. characterCount)
   * @param options Amplitude event options.
   */
  chatContinue(
    properties: ChatContinueProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatContinue(properties), options);
  }

  /**
   * Chat Generation Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Generation%20Completed)
   *
   * Fired when character response generation completes successfully
   *
   * @param properties The event's properties (e.g. characterId)
   * @param options Amplitude event options.
   */
  chatGenerationCompleted(
    properties: ChatGenerationCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatGenerationCompleted(properties), options);
  }

  /**
   * Chat Generation Error
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Generation%20Error)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatGenerationError(
    properties: ChatGenerationErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatGenerationError(properties), options);
  }

  /**
   * Chat Message Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Message%20Deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatMessageDeleted(
    properties: ChatMessageDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageDeleted(properties), options);
  }

  /**
   * Chat Message Edited
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Message%20Edited)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatMessageEdited(
    properties: ChatMessageEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageEdited(properties), options);
  }

  /**
   * Chat Message Regenerated
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Message%20Regenerated)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. characterId)
   * @param options Amplitude event options.
   */
  chatMessageRegenerated(
    properties: ChatMessageRegeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageRegenerated(properties), options);
  }

  /**
   * Chat Message Sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Message%20Sent)
   *
   * Fired when a user sends a message to a character.
   *
   * @param properties The event's properties (e.g. characterCount)
   * @param options Amplitude event options.
   */
  chatMessageSent(
    properties: ChatMessageSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageSent(properties), options);
  }

  /**
   * Chat Rewound
   *
   * [View in Tracking Plan](https://data.amplitude.com/moecorporation/staging/events/main/latest/Chat%20Rewound)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatRewound(
    properties: ChatRewoundProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatRewound(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
